import type {
  AssetProcessingActivityDetail,
  AssetProcessingDpiaLog,
} from 'config/api/assetProcessingActivities/assetProcessingActivities.types';
import areRopaApiMocksEnabled from 'config/api/ropaApiMocks';

export const MOCK_ASSET_PROCESSING_DPIA_LOG: AssetProcessingDpiaLog = {
  fileName: 'dpia-log.pdf',
};

export type ResolvedAssetProcessingDpiaLog = {
  canDownload: boolean;
  log: AssetProcessingDpiaLog;
  source: 'api' | 'mock';
};

export const resolveAssetProcessingDpiaLog = (
  detail?: Pick<AssetProcessingActivityDetail, 'dpiaLog'> | null,
): ResolvedAssetProcessingDpiaLog | null => {
  if (detail?.dpiaLog) {
    return {
      canDownload: true,
      log: detail.dpiaLog,
      source: 'api',
    };
  }

  if (areRopaApiMocksEnabled() && detail) {
    return {
      canDownload: false,
      log: MOCK_ASSET_PROCESSING_DPIA_LOG,
      source: 'mock',
    };
  }

  return null;
};
